import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../components";
import { Form } from "react-bootstrap";
import {
  Box,
  Typography,
  Divider,
  Pagination,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilDaftarHasilStockOpname = () => {
  const { user, dispatch } = useContext(AuthContext);
  const screenSize = useScreenWidth();
  const navigate = useNavigate();
  const [isFetchError, setIsFetchError] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [hasilStockOpnamesData, setHasilStockOpnamesData] = useState([]);
  const kode = null;

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    getHasilStockOpnames();
  }, [page, searchTerm]);

  const getHasilStockOpnames = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/hasilStockOpnames`, {
        dariTanggal: user.tutupperiode.dariTanggal,
        sampaiTanggal: user.tutupperiode.sampaiTanggal,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      setHasilStockOpnamesData(response.data);
      setPages(Math.ceil(response.data.length / limit));
      setRows(response.data.length);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Box>
      <Typography color="#757575">Transaksi</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Daftar Hasil Stock Opname
      </Typography>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={"/"}
          kode={kode}
          addLink={`/daftarHasilStockOpname/hasilStockOpname/tambah`}
          editLink={`/`}
          deleteUser={"/"}
        />
      </Box>
      <Divider sx={dividerStyle} />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead
              sx={{
                "& .MuiTableCell-head": {
                  color: "white",
                  backgroundColor: "#1976d2",
                },
              }}
            >
              <TableRow>
                <TableCell>No. Bukti</TableCell>
                <TableCell>Tanggal</TableCell>
                <TableCell>COA</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {hasilStockOpnamesData
                .filter((row) =>
                  `${row.noBukti} ${row.tglHasilStockOpname} ${row.coa?.kodeCOA || ""} ${row.coa?.namaCOA || ""}`
                    .toUpperCase()
                    .includes(searchTerm.toUpperCase()),
                )
                .slice(page * limit, page * limit + limit)
                .map((row) => (
                  <TableRow
                    key={row.id}
                    hover
                    sx={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(
                        `/daftarHasilStockOpname/hasilStockOpname/${row.id}`,
                      )
                    }
                  >
                    <TableCell>{row.noBukti}</TableCell>
                    <TableCell>{row.tglHasilStockOpname}</TableCell>
                    <TableCell>
                      {row.coa
                        ? `${row.coa.kodeCOA} - ${row.coa.namaCOA}`
                        : "-"}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Box>
  );
};

export default TampilDaftarHasilStockOpname;

const container = {
  p: 4,
};

const subTitleText = {
  fontWeight: "900",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const dividerStyle = {
  pt: 4,
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
